import React, { Fragment } from 'react';
import URC from 'ui-react-common';
const { Divider, Type: { BodyTwo } } = URC.ui.components;


const ApplicationSubcopy = () => (
    <Fragment>
        <BodyTwo className="sprk-u-pbm">
                Our mission is simple - we want to make it easy for you to achieve more by getting the money you need, when you need it.
        </BodyTwo>
        <BodyTwo>
                To see what you pre-qualify for, fill out the form below. This step will not affect your credit score.
        </BodyTwo>
        <Divider className="sprk-u-MarginVertical--b"/>
    </Fragment>
);

export default ApplicationSubcopy;
